import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const OldNewPasswordValidator = (
    oldControlName: string,
    newControlName: string,
    repeatNewControlName: string,
): ValidatorFn => {
    return (control: AbstractControl): ValidationErrors | null => {
        const oldPassword = control.get(oldControlName);
        const newPassword = control.get(newControlName);
        const repeatNewPassword = control.get(repeatNewControlName);
        if (oldPassword && newPassword && (oldPassword.dirty || oldPassword.touched) && oldPassword.value === newPassword.value) {
            return { errorMsg: 'password.change.error.oldEqualNew' };
        } else if (repeatNewPassword && newPassword && (repeatNewPassword.dirty || repeatNewPassword.touched) && newPassword.value !== repeatNewPassword.value) {
            return { errorMsg: 'password.change.error.mismatch' };
        }

        return null;
    };
};